import { useRef } from 'react'
import { SITE } from '~/lib/site-config'
import { useUiStore } from '~/stores/ui-store'

// 이스터에그: 저작권 문구 7번 연속 클릭 시 숨김 서비스(변경 검토·모니터링) 노출/숨김 토글.
const TOGGLE_CLICK_COUNT = 7
// 이 간격(ms) 안에 이어진 클릭만 '연속'으로 센다.
const CLICK_WINDOW_MS = 1500

/** 하단 고정 푸터. 브랜드 · 저작권 · 공식 창구 링크. */
export function Footer() {
    const toggleHiddenServices = useUiStore((s) => s.toggleHiddenServices)
    const clickCount = useRef(0)
    const lastClickAt = useRef(0)

    const handleCopyrightClick = () => {
        const now = Date.now()
        clickCount.current =
            now - lastClickAt.current <= CLICK_WINDOW_MS
                ? clickCount.current + 1
                : 1
        lastClickAt.current = now
        if (clickCount.current >= TOGGLE_CLICK_COUNT) {
            clickCount.current = 0
            toggleHiddenServices()
        }
    }

    return (
        <footer className='bg-navy z-40 shrink-0 border-t border-white/15 text-white/72'>
            <div className='mx-auto flex h-11 max-w-7xl items-center justify-between gap-4 px-4 text-xs lg:px-8'>
                <a
                    href={SITE.orgUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='flex items-center gap-1.5 text-white transition-opacity hover:opacity-80'>
                    <span className='text-sm font-bold tracking-[0.15em]'>
                        PAI
                    </span>
                    <span className='border-l border-white/24 pl-1.5 text-[10px] tracking-[0.2em] text-white/70'>
                        HACCP AI
                    </span>
                </a>
                <p
                    onClick={handleCopyrightClick}
                    className='hidden select-none sm:block'>
                    &copy; {new Date().getFullYear()} {SITE.org}
                </p>
                <div className='flex items-center gap-3'>
                    <a
                        href={SITE.haccpUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='transition-colors hover:text-white'>
                        공식 HACCP 누리집
                    </a>
                    <a
                        href={SITE.foodSafetyUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='transition-colors hover:text-white'>
                        식품안전나라
                    </a>
                </div>
            </div>
        </footer>
    )
}
